const actionTypes = {
  SET_COURSE_PACKAGE_DETAIL: 'SET_COURSE_PACKAGE_DETAIL',
  SET_COURSENAME: 'SET_COURSENAME'
};
export default actionTypes;